import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import sitekeyPagesRoleManagement from '../../staticRoleManagement/sitekeyRoleManagement'
import useStyles from './styles/SitekeyFooter.styles'

interface SitekeyFooterProps {
  isValid: boolean
  isSubmitting: boolean
  areAllLogosUploaded: boolean
  loadingForUpdateSitekey: boolean
}

const SitekeyFooter: React.FC<SitekeyFooterProps> = ({
  isValid,
  isSubmitting,
  areAllLogosUploaded,
  loadingForUpdateSitekey
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const hasAccessToCreateSiteKey = sitekeyPagesRoleManagement
    .find((item) => item.route === '/sitekeys/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  const hasAccessToModifySiteKey = sitekeyPagesRoleManagement
    .find((item) => item.route === '/sitekeys/:id/edit')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        fullWidth={matches}
        disabled={
          !!!isValid ||
          isSubmitting ||
          !areAllLogosUploaded ||
          !hasAccessToCreateSiteKey ||
          !hasAccessToModifySiteKey ||
          loadingForUpdateSitekey
        }
        type="submit">
        {getTranslate('Save Sitekey')}
        {loadingForUpdateSitekey && (
          <CircularProgress
            className={classes.circularProgress}
            size={16}
            color="primary"
          />
        )}
      </Button>
    </div>
  )
}
export default SitekeyFooter
